import React from 'react';
import cn from '../../utils/cn';

const sizes = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-20 h-20 text-2xl',
};

const Avatar = ({ src, name = '', size = 'md', className = '' }) => {
  const initials = name.split(' ').map((n) => n[0]).slice(0, 2).join('').toUpperCase();

  return (
    <div className={cn('rounded-full overflow-hidden flex items-center justify-center bg-primary-600 text-white font-semibold flex-shrink-0', sizes[size], className)}>
      {src ? <img src={src} alt={name} className="w-full h-full object-cover" /> : initials}
    </div>
  );
};

export default Avatar;
